<section class="footer-bitcar">
  <div class="content-center">

    <div class="content-footer">
      <div class="container-logos img-logo">

        <div>

          <img src="./assets/img/v3/leasing-header-logo.svg" alt="bitcar-logo">

        </div>
        <mat-divider></mat-divider>

        <div class="logos-afiliados">
          <img src="./assets/img/v3/leasing-footer-logo-profeco.svg" alt="bitcar-profeco">
          <img src="./assets/img/v3/leasing-footer-logo-verified.svg" alt="bitcar-verified">
          <img src="./assets/img/v3/leasing-footer-logo-bitcar.svg" alt="bitcar-sostenibilidad">

        </div>

        <div fxHide.xs fxHide.sm>

          <div class="bt-footer-sociales">
            <p class="followus">Siguenos</p>
            <div class="icons-social">
              <a href="https://www.facebook.com/bitcar.mx" target="_blank" rel="noopener noreferre"><mat-icon
                  svgIcon="icon-fb" aria-hidden="false" aria-label="fb"></mat-icon></a>
              <a href="https://www.instagram.com/bitcarmexico" target="_blank" rel="noopener noreferre"><mat-icon
                  svgIcon="icon-insta" aria-hidden="false" aria-label="insta"></mat-icon></a>
              <a href="https://www.linkedin.com/company/bitcar-mx" target="_blank" rel="noopener noreferre"><mat-icon
                  svgIcon="icon-linkedin" aria-hidden="false" aria-label="linkedin"></mat-icon></a>
              <a href="https://twitter.com/bitcar_mx" target="_blank" rel="noopener noreferre"><mat-icon
                  svgIcon="icon-x" aria-hidden="false" aria-label="x"></mat-icon></a>
              <a href="https://www.youtube.com/channel/UCFhsKmBa85oBCWrfXw0Ln9w" target="_blank"
                rel="noopener noreferre"><mat-icon svgIcon="icon-youtube" aria-hidden="false"
                  aria-label="youtube"></mat-icon></a>

            </div>

          </div>

        </div>




      </div>

      <div class="container-logos" style="justify-content: center !important;">

        <ul class="list-unstyled">
          <li class="li-menu"><a href="/v2/buscador">Autos <span class="next-arrow">></span></a> </li>
          <li class="li-menu"><a href="https://blog.bitcar.mx/">Blog <span class="next-arrow">></span></a> </li>

        </ul>


      </div>


      <div class="container-logos">

        <p class="sectionTitle">Legales</p>
        <ul class="list-unstyled">
          <li class="li-menu"><a (click)="setTitle('Bitcar - Política de Privacidad')"
              href="/v2/landing#aviso-privacidad">Política
              de Privacidad <span class="next-arrow">></span></a></li>
          <li class="li-menu"><a (click)="setTitle('Bitcar - Términos y Condiciones')"
              href="/v2/landing#terminos-condiciones">Términos y Condiciones <span class="next-arrow">></span></a></li>
          <li class="li-menu"><a (click)="setTitle('Bitcar - Política de Cookies')"
              href="/v2/landing#politica-cookies">Política de
              Cookies <span class="next-arrow">></span></a></li>
          <li class="li-menu"><a (click)="setTitle('Bitcar - Promociones')" href="/v2/landing#promociones">Promociones <span
                class="next-arrow">></span></a></li>

        </ul>

      </div>

      <div class="container-logos">
        <p class="sectionTitle">Ayuda</p>
        <ul class="list-unstyled">
          <li class="li-menu"><a (click)="setTitle('Bitcar - Preguntas Frecuentes')" href="/v2/landing#faqs">Preguntas
              Frecuentes
              <span class="next-arrow">></span></a></li>
          <li class="li-menu"><a (click)="setTitle('Bitcar - Buzón de Transparencia')"
              href="/v2/landing#buzon-transparencia">Buzón
              de Transparencia <span class="next-arrow">></span></a></li>
        </ul>
      </div>

      <div fxHide.gt-sm>

        <div class="bt-footer-sociales">
          <p class="followus">Siguenos</p>
          <div class="icons-social">
            <a href="https://www.facebook.com/bitcar.mx" target="_blank" rel="noopener noreferre"><mat-icon
                svgIcon="icon-fb" aria-hidden="false" aria-label="fb"></mat-icon></a>
            <a href="https://www.instagram.com/bitcarmexico" target="_blank" rel="noopener noreferre"><mat-icon
                svgIcon="icon-insta" aria-hidden="false" aria-label="insta"></mat-icon></a>
            <a href="https://www.linkedin.com/company/bitcar-mx" target="_blank" rel="noopener noreferre"><mat-icon
                svgIcon="icon-linkedin" aria-hidden="false" aria-label="linkedin"></mat-icon></a>
            <a href="https://twitter.com/bitcar_mx" target="_blank" rel="noopener noreferre"><mat-icon svgIcon="icon-x"
                aria-hidden="false" aria-label="x"></mat-icon></a>
            <a href="https://www.youtube.com/channel/UCFhsKmBa85oBCWrfXw0Ln9w" target="_blank"
              rel="noopener noreferre"><mat-icon svgIcon="icon-youtube" aria-hidden="false"
                aria-label="youtube"></mat-icon></a>

          </div>

        </div>

      </div>

    </div>


    <div class="content-disclaimers">

      <div class="content">
        <p class="text-disclaimer" *ngFor="let item of dataDisclaimers" [innerHTML]="item.disclaimer_content"></p>
      </div>
    </div>


  </div>
</section>